import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  LOGIN_USER_BY_CODE,
  RESET_ERROR_LOGIN,
  LOGIN_MFA_SUCCESS,
} from "./actionTypes"

export const loginUser = (user, history) => {
  return {
    type: LOGIN_USER,
    payload: { user, history },
  }
}

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  }
}

export const loginMfaSuccess = () => {
  return {
    type: LOGIN_MFA_SUCCESS
  }
}

export const loginUserByCode = (code, history) => {
  return {
    type: LOGIN_USER_BY_CODE,
    payload: { code, history },
  }
}

export const logoutUser = history => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const resetErrorLogin = () => {
  return {
    type: RESET_ERROR_LOGIN,
  }
}